<template>
    <div class="uk-padding">
        <div class="uk-container uk-container-small">
            <h2 class="uk-text-center "><span>Meet Our Leaders</span></h2><br>
            <ul class="uk-list uk-list-divider">
                <li>
                    <div uk-grid>
                        <div class="uk-width-auto@s">
                            <img  class="uk-align-center uk-align-left@s" src="/anderson.png" alt="">
                        </div>
                        <div class="uk-width-expand@s">
                            <ul class="uk-list uk-list-divider">
                                <li
                                        style="font-variant: all-small-caps; font-size: x-large; font-weight: bold; margin-top: 0px !important; padding-top: 0px !important;">
                                    Mr. Anthonio Anderson</li>
                                <li class="uk-text-muted" style="font-variant: all-small-caps; font-size: large; margin-top: 0px !important; padding-top: 0px !important;">Chief Information Officer, Aeorion Software Solutions</li>
                                <li class="uk-text-muted" style="font-variant: all-small-caps; font-size: large; margin-top: 0px !important; padding-top: 0px !important;">
                                    Mantra:
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div uk-grid>
                        <div class="uk-width-auto@s">
                            <img  class="uk-align-center uk-align-left@s" src="/chin.png" alt="">
                        </div>
                        <div class="uk-width-expand@s">
                            <ul class="uk-list uk-list-divider">
                                <li
                                        style="font-variant: all-small-caps; font-size: x-large; font-weight: bold; margin-top: 0px !important; padding-top: 0px !important;">
                                    Mr. Renaud Chin</li>
                                <li class="uk-text-muted" style="font-variant: all-small-caps; font-size: large; margin-top: 0px !important; padding-top: 0px !important;">Director, Aeorion Software Solutions</li>
                                <li class="uk-text-muted" style="font-variant: all-small-caps; font-size: large; margin-top: 0px !important; padding-top: 0px !important;">
                                    Mantra:
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li><br>
                    <div uk-grid>
                        <div class="uk-width-auto@s">
                            <img class="uk-align-center uk-align-left@s" src="/allie.png" alt="">
                        </div>
                        <div class="uk-width-expand@s">
                            <ul class="uk-list uk-list-divider">
                                <li
                                        style="font-variant: all-small-caps; font-size: x-large; font-weight: bold; margin-top: 0px !important; padding-top: 0px !important;">
                                    Mr. Imran Allie</li>
                                <li class="uk-text-muted" style="font-variant: all-small-caps; font-size: large; margin-top: 0px !important; padding-top: 0px !important; ">Asst Director, Aeorion Software Solutions</li>
                                <li class="uk-text-muted" style="font-variant: all-small-caps; font-size: large; margin-top: 0px !important; padding-top: 0px !important; ">
                                    Mantra:
                                </li>
                            </ul>
                        </div>

                    </div>
                </li>

            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "leaders"
    }
</script>

<style scoped>
    img{
        max-width: 150px;
        max-height: 150px;
        width: auto;
        height: auto;
    }
</style>